import { Component, OnInit, ElementRef, AfterViewChecked } from '@angular/core';

import { ControlTypeName } from '../../types/control-type-name';
import { TextBoxViewModel } from '../../types/control.types';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';

@Component({
  selector: 'df-digital',
  templateUrl: './digital.component.html',
  styleUrls: ['./digital.component.css']
})
export class DigitalComponent extends AbstractValueControlBase<TextBoxViewModel> implements OnInit, AfterViewChecked {
  type: string = ControlTypeName.digital;
  isDesign: boolean = false;
  model: TextBoxViewModel;

  constructor(protected element: ElementRef) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.model['placeholder'] === undefined) {
      this.model['placeholder'] = '';
    }
  }

  ngAfterViewChecked(): void {
    this.handleValueChangeNotByAngularWay();
  }

  valueChange(event: Event) {
    this.validate();
    super.valueChange(event);
  }
}
